import React, { useEffect, useState } from 'react';
import './RunningTotal.css';
// Type Definitions
interface RowData {
  proc_date?: string;
  schedule_start_time?: string;
  edited_schedule_time_start?: string;
  simulated_proc_time?: number;
  mach_code?: string;
  mach_name?: string;
}

interface Props {
  rowData: RowData[];
}

const RunningTotal: React.FC<Props> = ({ rowData }) => {
  const [totalsByDate, setTotalsByDate] = useState<{ [date: string]: number }>({});

  useEffect(() => {
    calculateTotal();
  }, [rowData]);

  const calculateTotal = () => {
    const totals: { [date: string]: number } = {};

    rowData.forEach((row) => {
      if (row.edited_schedule_time_start !== null && row.edited_schedule_time_start !== '') {
        // 日付の部分だけを抽出（形式が "YYYY-MM-DD" などの場合）
        if (row.edited_schedule_time_start !== null && row.edited_schedule_time_start !== undefined) {
          const date = row.edited_schedule_time_start.split('T')[0];



          if (!totals[date]) {
            totals[date] = 0;
          }

          if (row.simulated_proc_time !== undefined && row.simulated_proc_time !== null) {
            totals[date] += row.simulated_proc_time;
          }
        }
      }
    });

    setTotalsByDate(totals);
  };

  // totalsByDate を "x時間y分" の形式に変換して表示
  const displayTotals = Object.entries(totalsByDate).map(([date, totalInSeconds]) => {
    const hours = Math.floor(totalInSeconds / 3600);
    const minutes = Math.floor((totalInSeconds % 3600) / 60);
    return (
      <div key={date}>
        {date}: {hours}時間{minutes}分
      </div>
    );
  });

  return (
    <div className="analysis-container">
      <h2>{displayTotals}</h2>
    </div>
  );
};

export default RunningTotal;